import React from 'react';
import sctheme from 'app/styles/sctheme';

export const CannotDeleteTooltip = () => {
  return (
    <div
      className="position-absolute"
      style={{
        color: sctheme.grays.black,
        top: '50%',
        right: '2rem',
        transform: 'translateY(-50%)',
        backgroundColor: sctheme.white,
        border: `1px solid ${sctheme.grays.$600}`,
        padding: '0.25rem 0.5rem',
        fontSize: '12px',
        borderRadius: '4px',
        textAlign: 'left',
        width: '12rem'
      }}
    >
      Cannot delete last subscriber. Delete batch instead.
    </div>
  );
};
